import { getTaxCertificationsAsync } from '../../../API/taxCertifications/getTaxCertificationsAsync';
import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { createDefaultTaxCertificationList } from 'ui-toolkit/taxCertifications/ITaxCertification';

export const { slice: taxCertificationSlice, asyncAction: getTaxCertificationAsyncAction } =
  createAsyncSliceWithDataAndQuery(
    'taxCertificationSlice',
    getTaxCertificationsAsync,
    createDefaultTaxCertificationList()
  );
